import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

interface CarouselArrowProps {
    direction: 'previous' | 'next';
    size?: 'sm' | 'lg';
    onClick: () => void;
}

const SIZE_CLASS = { sm: 'h-8 w-8', lg: 'h-11 w-11' } as const;
const ICON_SIZE_CLASS = { sm: 'h-4 w-4', lg: 'h-6 w-6' } as const;
const SIDE_CLASS = { sm: 'left-2', lg: 'left-3' } as const;
const END_SIDE_CLASS = { sm: 'right-2', lg: 'right-3' } as const;

export function CarouselArrow({ direction, size = 'sm', onClick }: CarouselArrowProps) {
    const Icon = direction === 'previous' ? ChevronLeftIcon : ChevronRightIcon;
    const side = direction === 'previous' ? SIDE_CLASS[size] : END_SIDE_CLASS[size];
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={direction === 'previous' ? 'Previous image' : 'Next image'}
            className={`absolute top-1/2 -translate-y-1/2 ${side} ${SIZE_CLASS[size]} grid place-items-center rounded-full border border-gray-200 bg-white/90 text-gray-700 shadow-sm transition-colors hover:bg-white hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400`}
        >
            <Icon className={ICON_SIZE_CLASS[size]} aria-hidden="true" />
        </button>
    );
}
